// Login.js

import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BtnComponent } from '../../components/button';
import { InputField } from '../../components/reactHookFormFields/inputField';
import { useGroupChatContext } from '../../context/groupchatContext';
import { chatLogin, organizationConfig } from '../../services/login';
import ethizologo from "../../assets/images/logo-login.svg";
import { MaskField } from '../../components/reactHookFormFields/maskField';
import PinCodeCard from './pincode';
import { convertPhoneNumberFromMask, setBaseUrl } from '../../helpers/utility';
import { Input } from '../../components/reactHookFormFields/input';
import { Mask } from '../../components/reactHookFormFields/mask';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import AuthVerification from './2fa';
import { useSelector, shallowEqual, useDispatch } from "react-redux";

const Login = () => {

    const[isProcessing, setIsProcessing] = useState(false);
    const[isJoiningchat, setisJoiningchat] = useState(false);
    const[visibleSection, setVisibleSection] = useState('login');
    const [inputVisibility, setInputVisibility] = useState(false);

    const { user, practiceId } = useSelector(
        ({ auth }) => ({
          user: auth?.user,
          practiceId: auth?.practice_id,

        }),
        shallowEqual
    );

    const navigate = useNavigate();
    const groupChatContext = useGroupChatContext();

    const {setAuthData,setIsOpenChangePinCodePopup,isShowPinCreateScreenOnFirstLogin,setIsShowPinCreateScreenOnFirstLogin,isOpen2FaPopup, setForceOpen2FaPopup} = useMemo(() => ({
        setAuthData: groupChatContext.setAuthData,
        setIsOpenChangePinCodePopup: groupChatContext.setIsOpenChangePinCodePopup,
        isShowPinCreateScreenOnFirstLogin: groupChatContext.isShowPinCreateScreenOnFirstLogin,
        setIsShowPinCreateScreenOnFirstLogin: groupChatContext.setIsShowPinCreateScreenOnFirstLogin,
        setForceOpen2FaPopup: groupChatContext.setForceOpen2FaPopup

    }));

    const fetchOrganizationConfig = () =>{
        organizationConfig().then((res) => {
            if(res?.data?.response.code == 0){
               localStorage.setItem('organization_config', JSON.stringify(res?.data?.response.data));
            }
            else {
                toast.error(res?.data?.response?.msg);
            }
        });
    }

    useEffect(()=>{
        fetchOrganizationConfig();
    }, [])

    // Login form
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {},
    });

    // join form
    const {
        handleSubmit: handleJoinFormSubmit,
        control: joinFormControl,
        getValues: getJoinFormValues,
        formState: { errors: joinFormErrors },
     } = useForm({
        defaultValues: {},
    });

    const handleLogin = (values, form_name) => {
        
        if(form_name != '2fa_form'){
            setBaseUrl(values?.practice_code ? values?.practice_code?.trim()?.toLowerCase() : '');
        }

        form_name == 'join_form' ? setisJoiningchat(true) : setIsProcessing(true);
        chatLogin({...values, isJoinForm: form_name == 'join_form' ? true : false}).then((res) => {

            const { code, msg, data } = res?.data?.response || {};

            if((code === -1 || code === "-1") && (msg || "")?.toLowerCase()?.includes("code verification expired")) {
                toast.error(msg);
                setTimeout(() => {
                    localStorage.removeItem('auth');
                    localStorage.removeItem('chatFilter');
                    window.location.reload();
                    return;
                }, 1200);
            }
            else {
                form_name == 'join_form' ? setisJoiningchat(false) : setIsProcessing(false);
                if(code === 0 || code === "0"){
                    if(data?.pincode_update_required === true){
                        setIsShowPinCreateScreenOnFirstLogin(true);
                        localStorage.setItem('createPinOnFirstLogin', true);
                        setIsOpenChangePinCodePopup(true);
                    } else {
                        setAuthData(data?.pincode);
                    }
                    if(form_name == 'join_form'){
                        setVisibleSection('pin_code');
                        toast.success(msg);
                    }
                    else{
                        localStorage.removeItem('auth');
                        localStorage.removeItem('chatFilter');
                        localStorage.setItem('auth', JSON.stringify(data || {}));
                        setAuthData(data);
                        setTimeout(() => {
                            if(data?.two_factor_auth_enabled == false ){
                             
                                setForceOpen2FaPopup(true);
                            }
                            if(data?.two_factor_auth_enabled){
                                setVisibleSection('2fa');
                            } else {
                                navigate('/')
                            }
                        }, 1000)
                    }
                }
                else {
                    toast.error(msg);
                }
            }
        });
    };

    const handleJoinchat = (values) => {
        handleLogin({phone: convertPhoneNumberFromMask(values.phone), practice_code: values.join_practice_code}, 'join_form');
    }

    return (
        <>
            
            <div className='min-h-screen'>
                <div className="flex justify-center items-center pt-4 md:pt-[5rem] py-4">
                    <img src={ethizologo} alt="logo" className="w-40"></img>
                </div>
                {visibleSection == '2fa' ? <AuthVerification triggerLoginCall={handleLogin} /> : null }
                {visibleSection == 'pin_code' ?
                    <div className="flex items-center justify-center">
                        <PinCodeCard phone={convertPhoneNumberFromMask(getJoinFormValues('phone'))} />
                    </div>
                    : null
                }
                {visibleSection == 'login' ?
                    <div className='mt-4 login-container w-4/5 md:w-2/3 mx-auto'>
                        <div className="flex flex-col md:flex-row items-start gap-4 p-4 justify-center">
                            
                            <div className=" flex-1 w-full">
                                <div className="flex min-h-full flex-col px-6 py-6 lg:px-8">
                                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                                        <h2 className="text-start text-2xl font-medium leading-9 tracking-tight text-gray-900">Sign in to your account</h2>
                                    </div>

                                    <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                                        <form className="space-y-6" name="login_form" onSubmit={handleSubmit(handleLogin)} >
                                            <div className="mt-2">
                                                <Input
                                                    title="Username"
                                                    name="username"
                                                    control={control}
                                                    rules={{
                                                        required: {
                                                            value: true,
                                                            message: "Please enter Username",
                                                        },
                                                    }}
                                                    errors={errors}
                                                />
                                            </div>
                                            <div className="mt-2 relative">
                                                <Input
                                                    title="Password"
                                                    name="password"
                                                    type={inputVisibility ? 'text' : 'password'}
                                                    control={control}
                                                    rules={{
                                                        required: {
                                                            value: true,
                                                            message: "Please enter Password",
                                                        },
                                                    }}
                                                    errors={errors}
                                                />
                                                <span className='cursor-pointer absolute top-[34px] right-2 text-gray-500' onClick={() => setInputVisibility(!inputVisibility)}>
                                                    {!inputVisibility ? <FaEye /> : <FaEyeSlash />}
                                                </span>
                                            </div>
                                            <div className="mt-2">
                                                <Input
                                                    title="Organization Code"
                                                    name="practice_code"
                                                    control={control}
                                                />
                                            </div>
                                            <BtnComponent btnType='primary' type="submit" className="flex w-full justify-center px-3 py-2 text-lg font-bold border border-ethizo_primary rounded-md bg-ethizo_primary text-[14px] text-white hover:bg-primary-hover hover:border-primary-hover" loading={isProcessing} text="Login" />

                                            {/* <div>
                                                <div className="flex items-center justify-between">
                                                    <label for="password" className="block text-sm font-medium leading-6 text-gray-900">Password</label>
                                                    <div className="text-sm">
                                                        <a href="#" className="font-semibold text-teal-600 hover:text-teal-900">Forgot password?</a>
                                                    </div>
                                                </div>
                                                <div className="mt-2">
                                                    <input id="password" name="password" type="password" autocomplete="current-password" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                                                </div>
                                            </div> */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className=" flex-1 w-full h-[20.7rem] md:h-[21.7rem]">
                                <div className="flex min-h-full flex-col px-6 py-6 lg:px-8">
                                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                                    <h2 className="text-start text-2xl font-medium leading-9 tracking-tight text-gray-900">Join with phone number </h2>
                                    </div>
                                    <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                                        <form className="space-y-6" name="join_form" onSubmit={handleJoinFormSubmit(handleJoinchat)}>
                                            <div>
                                                <div className="mt-2">
                                                    <Mask
                                                        mask="(999) 999-9999"
                                                        title="Phone"
                                                        name="phone"
                                                        control={joinFormControl}
                                                        rules={{
                                                            required: {
                                                                value: true,
                                                                message: "Please enter Phone",
                                                            },
                                                            pattern: {
                                                                value: /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                                                                message: "Please Enter Correct Number",
                                                            },
                                                        }}
                                                        errors={joinFormErrors}
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <Input
                                                        title="Organization Code"
                                                        name="join_practice_code"
                                                        control={joinFormControl}
                                                    />
                                                </div>
                                            </div>
                                            <BtnComponent btnType='primary' type="submit" className="flex w-full justify-center px-3 py-2 text-lg font-bold border border-ethizo_primary rounded-md bg-ethizo_primary text-[14px] text-white hover:bg-primary-hover hover:border-primary-hover" loading={isJoiningchat} text="Join" />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center py-2 bg-slate-500  rounded-lg rounded-t-none">
                            <div className="text-center">
                                <a href="/auth/forgot-password" className="text-white hover:underline">
                                    Forgot Password
                                </a>
                            </div>
                        </div>
                    </div>
                    : null
                }
            </div>
        </>
    );
};

export default Login;
